import Vue from 'vue'
import App from './App.vue'
import { router } from './router'
import store from './store'
import i18n from './i18n'
import './class-component-hooks'

/* Bootstrap */
import { BootstrapVue } from 'bootstrap-vue'
Vue.use(BootstrapVue)

/* Fonts Awesome */
import { dom, library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon)

/* Sentry */
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

if (process.env.VUE_APP_SENTRY_ENV !== 'dev') {
  Sentry.init({
    Vue,
    dsn: 'https://0a17433230b04e9994740e544d6a9456@digital-sentry.ddns.net/10',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['localhost', 'digital.etu.ru', /^\//],
      }),
    ],
    ignoreErrors: [
      'ChunkLoadError',
      '{no status}',
      'Navigation cancelled from',
      'Cannot redefine property: googletag',
      'Redirected when going from',
      'Avoided redundant navigation',
      'Loading CSS chunk',
      '[IGNORE]',
    ],
    release: process.env.VUE_APP_RELEASE,
    environment: process.env.VUE_APP_SENTRY_ENV,
    normalizeDepth: 4,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: Number(process.env.VUE_APP_SENTRY_TRACE_RATE),
  })
}

library.add(fas, far)
dom.watch()

/* Form Generator */
import VueFormGenerator from 'vue-form-generator'
Vue.use(VueFormGenerator)

/* Custom Field */
import AgGridField from '@/components/fields/AgGrid.vue'
import {
  Components as ORPKComponents,
  VueFormGeneratorFields as ORPKFields,
} from '@it/orpk-vue-ui'
import AwesomeMaskInput from '@/components/fields/AwesomeMaskInput.vue'

Vue.component('MainCard', ORPKComponents.MainCard)
Vue.component('CookiesUsage', ORPKComponents.CookiesUsage)
Vue.component('InfoModal', ORPKComponents.InfoModal)
Vue.component('WarningModal', ORPKComponents.WarningModal)
Vue.component('ClassicCKEditor', ORPKComponents.ClassicCKEditor)
Vue.component('fieldCKEditor', ORPKFields.CKEditor5Field)
Vue.component('DevServerModal', ORPKComponents.DevServerModal)
Vue.component('LoadingBottomCard', ORPKComponents.LoadingBottomCard)

Vue.component('fieldAwesomeMaskInput', AwesomeMaskInput)
Vue.component('fieldAgGrid', AgGridField)
Vue.component('fieldBootstrap', ORPKFields.BootstrapInput)
Vue.component('fieldBootstrapCheckbox', ORPKFields.BootstrapCheckbox)
Vue.component('fieldBootstrapCheckboxGroup', ORPKFields.BootstrapCheckboxGroup)
Vue.component('fieldBootstrapDatepicker', ORPKFields.BootstrapDatepicker)
Vue.component('fieldBootstrapRadioGroup', ORPKFields.BootstrapRadioGroup)
Vue.component('fieldBootstrapSelect', ORPKFields.BootstrapSelect)
Vue.component('fieldBootstrapTextArea', ORPKFields.BootstrapTextArea)
Vue.component('fieldDatepicker', ORPKFields.DatepickerField)
Vue.component('fieldMultiselect', ORPKFields.MultiselectField)
Vue.component('fieldHeaderSeparator', ORPKFields.HeaderSeparator)
Vue.component('LoadingBottomCard', ORPKComponents.LoadingBottomCard)

Vue.config.productionTip = false

if (process.env.NODE_ENV === 'production') {
  Vue.config.devtools = false
  Vue.config.silent = true
}

store.dispatch('user/fetchCurrentUser').then(() => {
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#app')
})
